import { THeader } from './THeader';

export const TSiteTemplate = ({ children, currentIndex = 0, onSectionTap }) => {
  return (
    <div style={{
      position: 'relative',
      width: '100%',
      minHeight: '100vh',
      color: 'var(--text-primary)',
    }}>
      <THeader currentIndex={currentIndex} onSectionTap={onSectionTap} />
      <main style={{ width: '100%', height: '100%' }}>
        {children}
      </main>
    </div>
  );
};
